<script>
import { routeStartsWith, routeIsSettings } from '@/helpers/routes'

export default {
  name: 'top-menu-professional',

  computed: {
    routeIsSettings () {
      return routeIsSettings(this.$route)
    },
    routerIsPatientAgendaSearch () {
      return routeStartsWith(this.$route, 'patient.agendas.search')
    },
    routerIsPatientAgendaSchedulings () {
      return routeStartsWith(this.$route, 'patient.agendas.schedulings')
    },
    routerIsFavoriteList () {
      return routeStartsWith(this.$route, 'patient.favorite-list.index')
    }
  }
}
</script>

<template lang="pug">
    ul
      li(:class="{'active': routeIsSettings}")
        router-link(:to="{name: 'settings.profile.me'}")
          a(href='#') Meu Perfil

      li(:class="{'active': routerIsPatientAgendaSearch}")
        router-link(:to="{name: 'patient.agendas.search'}")
          a(href='#') Agendar Consulta
      li(:class="{'active': routerIsPatientAgendaSchedulings}")
        router-link(:to="{name: 'patient.agendas.schedulings'}")
          a(href='#') Minha Agenda
      li(:class="{'active': routerIsFavoriteList}")
        router-link(:to="{name: 'patient.favorite-list.index'}")
          a(href='#') Meus Médicos
</template>



// WEBPACK FOOTER //
// src/layout/headers/topMenuPatient.vue